import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { type ActionItem, showToast } from 'shared/ui'
import { logger } from 'shared/lib'
import { type IResponseCustomDomain, ShortLinkApi } from 'entities/ShortLink'
import type { UrlShortener } from 'entities/ShortLink/model/UrlShortener'
import type { UrlShortenerModalStore } from 'pages/settings/pages/urlShortener/store/urlShortenerModalStore'

export const deleteCustomDomain = (
  store: UrlShortenerModalStore,
  urlShortener: UrlShortener,
  onSuccess: () => Promise<IResponseCustomDomain | never[]>
): ActionItem => {
  const onDelete = () => {
    modalStore.addModal({
      id: store.idModal,
      type: ModalTypeList.ALERT,
      title: 'Delete domain?',
      desc: (
        <>
          Removing this domain will switch your links back to the Salesmsg default short link domain
          and disable any existing short links <br /> that use it.
        </>
      ),
      primaryAction: {
        text: 'Delete',
        onAction: async () => {
          try {
            await ShortLinkApi.deleteCustomDomain(urlShortener.id)
            store.closeModal()

            showToast({
              type: 'success',
              title: 'Domain deleted',
            })

            await onSuccess()
          } catch (e) {
            logger.error(e)

            showToast({
              type: 'error',
              title: 'Something went wrong. Please try again',
            })
          }
        },
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: store.closeModal,
      },
    })
  }

  return {
    icon: 'delete',
    text: 'Delete',
    onAction: onDelete,
  }
}
